<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('nav.vendor') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.cost') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.vendor') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<div class="pull-right">
								<el-button type="primary" @click="createNew">{{ $t('nav.create-vendor') }}</el-button>
							</div>
							<el-input :placeholder="$t('vendor.filter')" v-model="keyword" class="input-with-select" style="width:500px">
							    <el-select v-model="category" slot="prepend"
							    :placeholder="$t('vendor.category')"
							    style="width:150px"
							    :clearable="true">
								    <el-option
								      v-for="item in vendorCategory"
								      :key="item.id"
								      :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
								      :value="item.id">
								    </el-option>
								  </el-select>
							    <el-button slot="append" icon="el-icon-search" @click="filterVendors"></el-button>
							</el-input>
						</div>
						
						<div class="card-body">
							<ul class="list">
								<VendorWidget :vendor="vendor" v-for="vendor in vendors" />
							</ul>
							
							<div class="flexbox padd-10">
								<el-pagination
								  background
								  layout="prev, pager, next"
								  :total="total"
								  @current-change="goPage">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- /row -->
		</div>	
	</div>
</template>
<script>
// @ is an alias to /src
import VendorWidget from '@/components/finance/VendorWidget.vue'

export default {
  name: 'VendoList',
  components: {
    VendorWidget
  },
  data: function() {
    return {
      vendors: [],
      keyword: '',
      category: null,
      total: 0,
      currentPage: 1,
      query: '',
      pageSize: 10
    }
  },
  methods: {
    createNew: function() {
      this.$router.push({ path: '/vendor/new' })
    },
    filterVendors: function() {
      this.currentPage = 1
      this.loadData()
    },
    goPage: function(page) {
      this.currentPage = page
      this.loadData()
    },
    loadData: function() {
      let that = this
          ,query = ''
      if (this.category)
        query += '?category=' + this.category
      if (this.keyword != '' && this.category)
        query += '&q=' + encodeURI(this.keyword)
      else if (this.keyword != '')
        query += '?q=' + encodeURI(this.keyword)
      this.query = query
      if (this.query != '')
        this.query += '&page=' + this.currentPage + '&size=' + this.pageSize
      else
        this.query = '?page=' + this.currentPage + '&size=' + this.pageSize
	  this.$http.get(this.API3_PREFIX + 'vendors' + this.query).then(function (response) {
		that.vendors = response.data.data
		that.total = response.data.rows_num
      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  created: function() {
    //get vendors
    this.loadData()
  }
}
</script>